import { render, staticRenderFns } from "./HImgTitleSmall.vue?vue&type=template&id=86d168c8&"
import script from "./HImgTitleSmall.vue?vue&type=script&lang=js&"
export * from "./HImgTitleSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports